import { render, staticRenderFns } from "./communityactivityapplicationDetail.vue?vue&type=template&id=bb4bd1d0&"
import script from "./communityactivityapplicationDetail.vue?vue&type=script&lang=js&"
export * from "./communityactivityapplicationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports